import React, { Component } from 'react';
import { connect } from 'react-redux';
import BaseElementDialog from '../BaseElementDialog/BaseElementDialog';
import _ from 'lodash';
import $ from 'jquery';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import LinearProgress from 'material-ui/LinearProgress';
import * as Colors from 'material-ui/styles/colors';
import transitions from 'material-ui/styles/transitions';
import * as ConnectEbayAccountService from 'shared/helpers/ConnectEbayAccountService';
import {getEbayAccounts} from 'MyAccount/ViewDesigns/helpers/preferencesHelper';
import {setEBayAccounts} from 'MyAccount/ViewDesigns/redux/modules/accountPage';
import {updateUserData} from 'MyAccount/ViewDesigns/redux/modules/user';
import InlineNotification, {LEVEL_INFO, LEVEL_NOTICE, LEVEL_ERROR} from 'crazyEditor/components/EditorUI/BaseUI/InlineMessages/InlineNotification';
import InlineButton from 'shared/components/InlineButton';
import { Link } from 'react-router';
import {EBayAccounts} from 'MyAccount/AccountPage/AccountPageSectionsData';
import ChildrenFader from 'shared/components/ChildrenFader';
import EbaySitesDropMenu from 'shared/components/EbaySitesDropMenu/EbaySitesDropMenu';
import {getCrossSellGalleryItemsIds} from 'crazyEditor/components/Elements/CrossSellGalleryElement/CrossSellGalleryHelper';

const NoticeMessage = (props) => {
  const {supportCrossSellGallery} = props;
  return (
    <div>
      The Cross Sell Gallery contains up to 25 most relevant products, automatically chosen based on our Best Match
      algorithm. &nbsp;
      <InlineButton
        href={supportCrossSellGallery}
        hoverColor="transparent"
        target="_blank"
        style={{color: Colors.blue700}}
      >
        Read more in our knowledge base
      </InlineButton>
    </div>
  );
};

function initSelectedSellerId(props) {
  const firstAccount = _.find(props.eBayAccounts, {first: true});
  if (firstAccount) {
    return firstAccount.UserID;
  }
  return null;
}

function getInitialState(props) {
  const firstSellerId = initSelectedSellerId(props);
  const initialStatus = firstSellerId ? <NoticeMessage {...props}/> : null;

  return {
    selectedSellerId: firstSellerId,
    selectedGlobalId: props.ebayGlobalIds['United States'],
    connectEbayAccountButtonLabel: 'CONNECT EBAY ACCOUNT',
    statusMessage: initialStatus,
    connectButtonDisabled: false,
    showNotice: true,
  };
}

@connect(
  state => ({
    eBayAccounts: state.accountPage.accounts,
    ebayGlobalIds: state.general.ebayGlobalIds,
    supportCrossSellGallery: state.general.supportLinks.supportCrossSellGallery,
    itemId: _.get(state.listingData, 'itemID'),
  }),
  {setEBayAccounts, updateUserData}
)
export default class CrossSellGalleryDialog extends Component {
  constructor(props) {
    super(props);
    this.state = getInitialState(props);
  }

  componentWillReceiveProps(nextProps) {
    const {eBayAccounts} = this.props;
    if (_.isEmpty(eBayAccounts) && !_.isEmpty(nextProps.eBayAccounts)) {
      window.setTimeout(this.closeSuccessMessage, 4000);
      this.setState({
        selectedSellerId: initSelectedSellerId(nextProps),
        statusMessage:
          <div>
            Ebay account connected successfully. You may &nbsp;
            <Link to={EBayAccounts.route} target="_blank">
              <InlineButton
                hoverColor="transparent"
                style={{color: Colors.lightGreen800}}
              >
                add other accounts
              </InlineButton>
            </Link>
            &nbsp; as well.
          </div>,
        showNotice: false,
      });
    }
  }

  getElementProps() {
    const {selectedSellerId, selectedGlobalId} = this.state;
    return {
      data: {
        sellerId: selectedSellerId,
        globalId: selectedGlobalId,
      }
    };
  }

  closeSuccessMessage = () => {
    this.setState({
      statusMessage: <NoticeMessage {...this.props}/>,
      showNotice: true,
    });
  };

  changeEbayAcount = (event, index, value) => {
    this.setState({selectedSellerId: value});
  };

  changeGlobalId = (event, index, value) => {
    this.setState({selectedGlobalId: value});
  };

  addEbayAccount = () => {
    const {setEBayAccounts, updateUserData} = this.props;
    this.setState({
      connectEbayAccountButtonLabel: 'AWAITING EBAY AUTHORIZATION',
      connectButtonDisabled: true,
      statusMessage: null,
    });
    ConnectEbayAccountService.launchAuth((status) => {
      switch (status) {
        case ConnectEbayAccountService.EBAY_CONNECT_STATUS.SUCCESS:
        case ConnectEbayAccountService.EBAY_CONNECT_STATUS.SWITCHED:
          getEbayAccounts().then(result => {
            if (result.success) {
              setEBayAccounts(result.eBayAccounts);
              updateUserData(result.user);
            }
          });
          break;
        case ConnectEbayAccountService.EBAY_CONNECT_STATUS.ERROR:
          this.setState({
            connectEbayAccountButtonLabel: 'TRY AGAIN',
            statusMessage:
              <div>
                Something went wrong. eBay Authentication failed. It may be due to a minor hickup so you might just&nbsp;
                <InlineButton onClick={this.addEbayAccount} style={{color: Colors.red900}}>try again</InlineButton>
                . If it doesn't work,&nbsp;
                <InlineButton
                  onClick={() => {
                    window.Intercom('showNewMessage',
                      'Hello Crazylister\n' +
                      'Something went wrong when I tried to connect an Ebay account. I tried again, but It still failed.\n' +
                      '\nWhat should I do?');
                  }}
                  style={{color: Colors.red900}}
                >ask for help</InlineButton>&nbsp;from Crazylister's team. We are always happy to help.
              </div>,
            connectButtonDisabled: false,
          });
          break;
        case ConnectEbayAccountService.EBAY_CONNECT_STATUS.DUPLICATE:
          this.setState({
            connectEbayAccountButtonLabel: 'TRY WITH A DIFFERENT ACCOUNT',
            statusMessage:
              <div>
                This eBay account is already connected to a different CrazyLister account. &nbsp;
                <InlineButton onClick={this.addEbayAccount} style={{color: Colors.red900}}>try again with a different account</InlineButton>.
              </div>,
            connectButtonDisabled: false,
          });
          break;
        case ConnectEbayAccountService.EBAY_CONNECT_STATUS.CANCEL:
          this.setState({
            connectEbayAccountButtonLabel: 'CONNECT EBAY ACCOUNT',
            connectButtonDisabled: false,
          });
          break;
        default:
          break;
      }
    });
  };

  render() {
    const {open, onCancel, onAddUpdate, newElement, eBayAccounts, ebayGlobalIds, itemId} = this.props;
    const {selectedSellerId, selectedGlobalId, connectEbayAccountButtonLabel, statusMessage, connectButtonDisabled, showNotice} = this.state;
    return (
      <BaseElementDialog
        open={open}
        newElement={newElement}
        title={`${newElement ? 'Add' : 'Edit'} Cross Sell Gallery`}
        ref="baseElementDialog"
        inputValid={selectedSellerId ? true : false}
        onAddUpdate={() => {
          const {eBayAccounts} = this.props;
          const {selectedSellerId, selectedGlobalId} = this.state;
          if (_.isEmpty(_.get(eBayAccounts, `${selectedSellerId}.crossSellItemsData.${selectedGlobalId}`))) {
            getCrossSellGalleryItemsIds(selectedSellerId, selectedGlobalId, itemId);
          }
          onAddUpdate(this.getElementProps());
        }}
        onCancel={() => {
          this.setState({...getInitialState(this.props)});
          onCancel();
        }}
      >
        <ChildrenFader path={!!selectedSellerId}>
          {selectedSellerId &&
          <div>
            <div>
              <InlineNotification
                open = {!!statusMessage}
                style = {{width: 'calc(100% - 40px)', height: 80, marginTop: 15, marginBottom: 15, marginLeft: 20, marginRight: 20, transition: transitions.easeOut()}}
                onRequestClose = {showNotice ? null : this.closeSuccessMessage}
                level = {showNotice ? LEVEL_NOTICE : LEVEL_INFO}
              >
                {statusMessage}
              </InlineNotification>
            </div>
            <div style={{width: '100%', marginTop: 30, marginLeft: 40}}>
              Select your eBay account
            </div>
            <div style={{width: '100%', marginTop: 10, marginLeft: 40}}>
              <SelectField
                value={selectedSellerId}
                onChange={this.changeEbayAcount}
                floatingLabelText="eBay User ID"
                floatingLabelStyle={{color: Colors.lightGreen700}}
              >
                {_.map(eBayAccounts, account =>
                  (<MenuItem key={account.UserID} value={account.UserID} primaryText={account.UserID} />)
                )}
              </SelectField>
            </div>
            <div style={{width: '100%', marginTop: 10, marginLeft: 40}}>
              <SelectField
                value={selectedGlobalId}
                onChange={this.changeGlobalId}
                floatingLabelText="eBay Site"
                floatingLabelStyle={{color: Colors.lightGreen700}}
                maxHeight={310}
              >
                {_.map(ebayGlobalIds, (globalId, siteName) =>
                  (<MenuItem key={globalId} value={globalId} primaryText={siteName} />)
                )}
              </SelectField>
            </div>
          </div>}
          {!selectedSellerId &&
          <div>
            <InlineNotification
              open = {!!statusMessage}
              style = {{width: 'calc(100% - 40px)', height: 80, marginTop: 15, marginBottom: 15, marginLeft: 20, marginRight: 20}}
              onRequestClose={() => {this.setState({statusMessage: null});}}
              level={LEVEL_ERROR}
            >
              {statusMessage}
            </InlineNotification>
            <div style={{width: '100%', marginTop: 30, marginLeft: 40}}>
              You have to connect an eBay account to be able to add a Cross Sell Gallery to your template
            </div>
            <div style={{width: '100%', marginTop: 30, marginLeft: 40, display: 'flex', alignItems: 'center'}}>
              <EbaySitesDropMenu />
              <RaisedButton
                style={{width: 260, marginLeft: 20}}
                label={connectEbayAccountButtonLabel}
                primary
                disabled={connectButtonDisabled}
                onClick = {this.addEbayAccount}
              >
                { connectButtonDisabled &&
                <LinearProgress mode="indeterminate" style={{position: 'absolute', bottom: 0, left: 0, width: '100%', backgroundColor: 'none'}}/>
                }
              </RaisedButton>
            </div>
          </div>}
        </ChildrenFader>
      </BaseElementDialog>
  );}
}
